// Accordion Animation
document.addEventListener('DOMContentLoaded', function () {
  initAccordions();
});

// También inicializar si el script se carga después del DOMContentLoaded
if (
  document.readyState === 'complete' ||
  document.readyState === 'interactive'
) {
  setTimeout(initAccordions, 1);
}

function initAccordions() {
  const accordions = document.querySelectorAll('.accordion details');

  accordions.forEach(function (accordion) {
    // Evitar agregar el listener múltiples veces
    if (accordion.hasAttribute('data-accordion-init')) return;
    accordion.setAttribute('data-accordion-init', 'true');

    const content = accordion.querySelector('.accordion__content');
    if (!content) return;

    // Si el accordion está abierto al cargar, establecer la altura
    if (accordion.open) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0px';
    }

    // Escuchar el evento toggle
    accordion.addEventListener('click', function (e) {
      // Solo procesar si se hizo clic en el summary
      if (!e.target.closest('summary')) return;

      e.preventDefault();

      const isOpen = accordion.open;

      if (isOpen) {
        // CERRAR: primero obtener altura actual, luego animar a 0
        const startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';

        // Usar requestAnimationFrame para mejor rendimiento en iOS
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // Animar a cerrado
            content.style.height = '0px';
            content.style.marginTop = '0px';
            content.style.marginBottom = '0px';
          });
        });

        // Esperar a que termine la animación para cerrar el details
        setTimeout(function () {
          accordion.open = false;
        }, 500);
      } else {
        // ABRIR: abrir primero, luego animar
        accordion.open = true;

        // Obtener la altura real del contenido
        const endHeight = content.scrollHeight;

        // Empezar desde 0
        content.style.height = '0px';
        content.style.marginTop = '0px';
        content.style.marginBottom = '0px';

        // Usar requestAnimationFrame para mejor rendimiento en iOS
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // Animar a la altura completa
            content.style.height = endHeight + 'px';
            content.style.marginTop = '1rem';
            content.style.marginBottom = '2rem';
          });
        });
      }
    });

    // Recalcular altura si cambia el tamaño de la ventana
    window.addEventListener('resize', function () {
      if (accordion.open) {
        content.style.height = content.scrollHeight + 'px';
      }
    });
  });
}

// Observar nuevos accordions que se agreguen dinámicamente
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.addedNodes.length) {
      initAccordions();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
